/* --------------------------------------------------------------------------------------
   browser.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class browserService {
  /* @ngInject */
  constructor(apiClientService) {
    this.apiClientService = apiClientService;
    this.hasMore = false;
    this.selectedClientId = null;
    this.selectedClientDisplayName = null;
  }

  async getNode(nodePath, nodeDisplayName, nodeEntryType, searchTerms) {
    let parameter = nodePath ? "/fs/" + nodePath : "/fs/%2F";
    //TODO: Please do this in a proper way
    parameter = parameter.replace("/null", "");
    if (searchTerms) {
      parameter = parameter + `?searchterm=${searchTerms}`;
    }
    const result = await this.apiClientService.get(parameter);
    result.DisplayName = nodeDisplayName;
    result.EntryType = nodeEntryType;
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/browser/services/browser.service.js